import { useQuery } from '@tanstack/react-query';

import { getSettingsGroups } from '../api/api';
import { SS_QUERY_KEY } from '../constants/constants';

export const useCustomerSettingsGroupsQuery = (enabled: boolean) => {
    const {
        data: customerGroupsData,
        isLoading: isCustomerGroupsDataLoading,
        error: customerGroupsDataError,
    } = useQuery({
        queryKey: [SS_QUERY_KEY.CUSTOMER_SETTINGS_GROUPS],
        queryFn: () => getSettingsGroups(),
        select: ({ data }) => data,
        enabled,
    });

    return {
        customerGroupsData,
        isCustomerGroupsDataLoading,
        customerGroupsDataError,
    };
};
